import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-4/5">
    <vx-card>
      <div class="inline-flex w-4/5 pb-2 mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>Inbound Number</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="inbordersNumber"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                  @click="searchInb"
                  >ดึงข้อมูล Inbound</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row mb-2" v-if="0 == 1">
        <div class="vx-col w-2/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            label-placeholder="Number"
            v-model="exbdetails"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-2/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="exbordersNumber"
            @blur="$v.exbordersNumber.$touch()"
            v-model="exbordersNumber"
            :readonly="true"
          />
        </div>
        <p v-if="$v.exbordersNumber.$error & $v.exbordersNumber.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ItemNumber"
            v-model="itemnum"
            :readonly="true"
          />
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 250px; text-align: right"
        >
          <span>Outbound Declaration No.</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-dollar-sign"
              icon-no-border
              label-placeholder="Declaration Number"
              v-model="dclnumber"
            />
          </div>
        </div>

        <div
          class="column is-narrow mt-6"
          style="width: 100px; text-align: right"
        >
          <span>ลงวันที่</span>
        </div>
        <div class="column is-narrow mt-5">
          <div style="width: 200px">
            <flat-pickr
              :config="configdateTimePicker"
              v-model="repdate"
              placeholder="Date"
              @blur="$v.repdate.$touch()"
            />
            <p v-if="$v.repdate.$error & $v.repdate.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 250px; text-align: right"
        >
          <span>Inbound Declaration No.</span>
        </div>
        <div class="column is-narrow -mt-3">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-dollar-sign"
              icon-no-border
              label-placeholder="Declaration Number"
              v-model="indclnumber"
              :readonly="true"
            />
          </div>
        </div>

        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>Invoice No.</span>
        </div>
        <div class="column is-narrow -mt-3">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="Invoice"
              v-model="invnum"
              :readonly="true"
            />
          </div>
        </div>

        <div
          class="column is-narrow mt-3"
          style="width: 80px; text-align: right"
        >
          <span>ลงวันที่</span>
        </div>
        <div class="column is-narrow -mt-3">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-calendar"
              icon-no-border
              label-placeholder="Inbound Date"
              v-model="indcldate"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns -mt-4">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>MAWB</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 1"
              v-model="mawb"
              @blur="$v.mawb.$touch()"
            />
            <p v-if="$v.mawb.$error & $v.mawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>

        <div
          class="column is-narrow mt-4"
          style="width: 100px; text-align: right"
        >
          <span>HAWB</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 200px">
            <vs-input
              :readonly="true"
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 2"
              v-model="hawb"
              @blur="$v.hawb.$touch()"
            />
            <p v-if="$v.hawb.$error & $v.hawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-2/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="SKUS_Code"
            v-model="inbdetailsSkuscode"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ItemNumber"
            v-model="inbitemnum"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 -mt-2">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span></span>
        </div>
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="QTY"
            @blur="$v.itemqty.$touch()"
            v-model="itemqty"
          />
        </div>
        <p v-if="$v.itemqty.$error & $v.itemqty.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="qtyunit"
          />
        </div>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Package"
            @blur="$v.itempck.$touch()"
            v-model="itempck"
          />
        </div>
        <p v-if="$v.itempck.$error & $v.itempck.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="packagesCode"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span></span>
        </div>
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="N/W"
            @blur="$v.itemnw.$touch()"
            v-model="itemnw"
          />
        </div>
        <p v-if="$v.itemnw.$error & $v.itemnw.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="nwunit"
          />
        </div>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="G/W"
            @blur="$v.itemgw.$touch()"
            v-model="itemgw"
          />
        </div>
        <p v-if="$v.itemgw.$error & $v.itemgw.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="gwunit"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2">
        <div
          class="column is-narrow mt-4"
          style="width: 240px; text-align: right"
        >
          <span>Description</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Description"
              v-model="description"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Shipper</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Shipper"
              v-model="shname"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Consignee</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Consignee"
              v-model="cnname"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>ประเภท</span>
        </div>
        <div class="column is-narrow mt-2">
          <div style="width: 200px">
            <vs-select
              autocomplete
              v-model="tmotypes_code"
              disabled="disabled"
              class="w-full"
            >
              <vs-select-item
                v-for="tmotype in tmotypes"
                :key="tmotype.code"
                :value="tmotype.code"
                :text="tmotype.name"
              />
            </vs-select>
            <p v-if="$v.tmotypes_code.$error & $v.tmotypes_code.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>ไปยัง</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-select
              autocomplete
              v-model="dest"
              disabled="disabled"
              class="w-full -mt-2"
            >
              <vs-select-item
                v-for="country in countrys"
                :key="country.code"
                :value="country.code"
                :text="country.name"
              />
            </vs-select>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>ผ่านทาง</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 350px">
            <vs-select
              autocomplete
              v-model="pod"
              disabled="disabled"
              class="w-full -mt-2"
            >
              <vs-select-item
                v-for="pol in pols"
                :key="pol.code"
                :value="pol.code"
                :text="pol.code + '-' + pol.name"
              />
            </vs-select>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>Remark</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vs-input
              class="w-full -mt-2"
              icon-pack="feather"
              icon="icon-eye"
              icon-no-border
              label-placeholder="Remark"
              v-model="remark"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          >
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vs-popup fullscreen title="Inbound Number" :active.sync="popupActive6">
      <inborders v-if="popupActive6" 
      :companyGroupsCode="companyGroupsCode"
      :masrec="0" 
      @recsel="recsel"></inborders>
    </vs-popup>
  </div>
</template>

<script>
import { required, decimal } from "vuelidate/lib/validators";
import moment from "moment";
import inborders from "./inbdetailsgrid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      indclnumber: "",
      indcldate: "",
      shname: "",
      cnname: "",
      description: "",
      pod: "",
      dest: "",
      tmotypes_code: "",
      pols: [],
      countrys: [],
      tmotypes: [],
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      repdate: "",
      inbdetailsSkuscode: "",
      qtyunit: "",
      itemgw: "",
      gwunit: "",
      itemnw: "",
      nwunit: "",
      itempck: "",
      packagesCode: "",
      dclnumber: "",
      mawb: "",
      hawb: "",
      exbdetails: "",
      exbordersNumber: "",
      invnum: "",
      itemnum: "",
      inbordersNumber: "",
      inbitemnum: "",
      itemqty: "",
      remark: "",
      status: "",
      readonly: false,
      popupActive6: false,
    };
  },
  validations: {
    exbordersNumber: {
      required,
    },
    itemqty: {
      required,
      decimal,
    },
    itempck: {
      required,
      decimal,
    },
    itemnw: {
      required,
      decimal,
    },
    itemgw: {
      required,
      decimal,
    },
    hawb: {
      required,
    },
    mawb: {
      required,
    },
    repdate: {
      required,
    },
    tmotypes_code: {
      required,
    },
  },
  components: {
    inborders,
  },
  props: ["acstate", "recid", "masrec"],
  methods: {
    async recsel(val) {
      this.inbordersNumber = val;
      // console.log(this.inbordersNumber);
      this.popupActive6 = false;

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        skus_code: val,
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/inbdetails/getInbDetail`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.inbordersNumber = response.data.inbordersNumber;
            this.inbitemnum = response.data.itemnum;
            this.description = response.data.edescription;
            this.itempck = response.data.itempck;
            this.packagesCode = response.data.packagesCode;
            this.itemnw = response.data.itemnw;
            this.nwunit = response.data.nwunit;
            this.itemgw = response.data.itemgw;
            this.gwunit = response.data.gwunit;
            this.itemqty = response.data.itemqty;
            this.qtyunit = response.data.qtyunit;
            this.mawb = response.data.mawb;
            this.hawb = response.data.hawb;
            this.inbdetailsSkuscode = response.data.skus_code;
            this.tmotypes_code = response.data.tmotypes_code;
            this.dest = response.data.dest;
            this.pod = response.data.pod;
            this.shname = response.data.shname;
            this.cnname = response.data.cnname;
            this.indclnumber = response.data.dclnumber;
            this.invnum = response.data.invnum;
            this.indcldate = response.data.dcldate;
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    searchInb() {
      // console.log("inb");
      this.popupActive6 = true;
    },
    clsd: function () {
      // this.exbdetails = this.itempck = this.packagesCode = this.itemnw = this.nwunit =
      // this.itemgw = this.gwunit = this.dclnumber = this.inbordersNumber = this.itemnum =
      // this.itemqty = this.remark = this.invnum = this.inbitemnum = this.inbdetailsSkuscode =
      //   "";
      this.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      // alert("Hi");
      this.$v.$touch();
      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      } else if (this.itempck == 0) {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Package can't be Zero",
          text: "Please Enter The Informaiton",
        });
        return;
      }

      const formData = {
        companyGroupsCode: this.companyGroupsCode,
        businessPartnersCode: this.businessPartnersCode,
        number: this.recid,
        exbordersNumber: this.exbordersNumber,
        invnum: this.invnum,
        itemnum: this.itemnum,
        inbordersNumber: this.inbordersNumber,
        inbitemnum: this.inbitemnum,
        itemqty: this.itemqty,
        remark: this.remark,
        acstate: this.acstate,
        recid: this.recid,
        inbdetailsSkuscode: this.inbdetailsSkuscode,
        mawb: this.mawb,
        dclnumber: this.dclnumber,
        repdate: this.repdate,
        shname: this.shname,
        cnname: this.cnname,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(this.ata);
      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
      // vm.$emit("grid");
      // vm.clsd();
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    // console.log("beforecreate");
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    const formData = {
      inbfrom: "DOM",
    };

    const response5 = await axios.post(
      `${BASE_API_URL}/outbound-svc/customsports/getCustomsPorts`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response5.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response5.data.message,
      });
    } else {
      this.pols = response5.data;
    }

    const response3 = await axios.post(
      `${BASE_API_URL}/outbound-svc/countrys/getCountrys`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response3.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response3.data.message,
      });
    } else {
      this.countrys = response3.data;
    }

    const response4 = await axios.post(
      `${BASE_API_URL}/outbound-svc/tmotypes/getTmotypesALL`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response4.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response4.data.message,
      });
    } else {
      this.tmotypes = response4.data;
    }
  },
  async created() {
    this.checkProfiles();
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    // console.log(this.recid);
    // console.log("create");
    const formData = {
      token: localStorage.getItem("token"),
      dbname: localStorage.getItem("dbname"),
      exbdetails: this.recid,
    };
    if (this.recid != "0") {
      // alert("Edit");
      this.readonly = true;

      try {
        const response = await axios.post(
          `${BASE_API_URL}/outbound-svc/exbdetails/getExbdetail`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.ffimp = response.data.ffimp;
          setTimeout(() => {
            this.exbdetails = response.data.number;
            this.exbordersNumber = response.data.exbordersNumber;
            this.itemnum = response.data.itemnum;
            this.inbordersNumber = response.data.inbordersNumber;
            this.inbitemnum = response.data.inbitemnum;
            this.itemqty = response.data.itemqty;
            this.qtyunit = response.data.qtyunit;
            this.remark = response.data.remark;
            this.status = response.data.status;
            this.invnum = response.data.invnum;
            this.packagesCode = response.data.packagesCode;
            this.itemnw = response.data.itemnw;
            this.nwunit = response.data.nwunit;
            this.itempck = response.data.itempck;
            this.itemgw = response.data.itemgw;
            this.gwunit = response.data.gwunit;
            this.dclnumber = response.data.dclnumber;
            this.inbdetailsSkuscode = response.data.inbdetailsSkuscode;
            this.mawb = response.data.mawb;
            this.hawb = response.data.hawb;
            this.repdate = response.data.repdate;
            this.indclnumber = response.data.indclnumber;
            this.shname = response.data.shname;
            this.cnname = response.data.cnname;
            this.pod = response.data.pod;
            this.dest = response.data.dest;
            this.tmotypes_code = response.data.tmotypesCode;
            this.indcldate = response.data.indcldate;
            this.description = response.data.description;
          }, 1000);
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
      vm.exbordersNumber = vm.masrec;
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
